import { initializeApp } from 'firebase/app';
import {
  getFirestore, collection, doc, addDoc, updateDoc, deleteDoc,
  onSnapshot, query, where, orderBy, serverTimestamp, getDoc,
} from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyCoZam77EfvxWiyu1R2IEaQjQ4Tl19VAlc",
  authDomain: "notepad-56a6a.firebaseapp.com",
  projectId: "notepad-56a6a",
  storageBucket: "notepad-56a6a.firebasestorage.app",
  messagingSenderId: "667137513139",
  appId: "1:667137513139:web:f1a212540ffda072a002c6",
};

export const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);

export const GOOGLE_MAPS_API_KEY = 'AIzaSyBrIDVK_fZFxi_XrA8THSn7IanTXk3gwiU';

// Real-time subscription to user's food places
export function subscribePlaces(userId, callback, onError) {
  const q = query(
    collection(db, 'foodPlaces'),
    where('userId', '==', userId),
    orderBy('createdAt', 'desc'),
  );
  return onSnapshot(q,
    snap => callback(snap.docs.map(d => ({ id: d.id, ...d.data() }))),
    err => { console.error('[subscribePlaces]', err.code, err.message); onError?.(err); },
  );
}

export async function addPlace(userId, data) {
  return addDoc(collection(db, 'foodPlaces'), {
    ...data,
    userId,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}

export async function updatePlace(id, data) {
  return updateDoc(doc(db, 'foodPlaces', id), {
    ...data,
    updatedAt: serverTimestamp(),
  });
}

export async function deletePlace(id) {
  return deleteDoc(doc(db, 'foodPlaces', id));
}

// Program overlay places (Kris+, Entertainer, Burrple)
export function subscribeProgramPlaces(callback, onError) {
  return onSnapshot(collection(db, 'programPlaces'),
    snap => callback(snap.docs.map(d => ({ id: d.id, ...d.data() }))),
    err => { console.error('[subscribeProgramPlaces]', err.code, err.message); onError?.(err); },
  );
}

// Shared lists
export async function createSharedList(ownerId, data) {
  return addDoc(collection(db, 'sharedLists'), {
    ...data,
    ownerId,
    places: data.places || [],
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  });
}

export async function updateSharedList(id, data) {
  return updateDoc(doc(db, 'sharedLists', id), {
    ...data,
    updatedAt: serverTimestamp(),
  });
}

export async function deleteSharedList(id) {
  return deleteDoc(doc(db, 'sharedLists', id));
}

export function subscribeSharedLists(ownerId, callback, onError) {
  const q = query(
    collection(db, 'sharedLists'),
    where('ownerId', '==', ownerId),
    orderBy('createdAt', 'desc'),
  );
  return onSnapshot(q,
    snap => callback(snap.docs.map(d => ({ id: d.id, ...d.data() }))),
    err => { console.error('[subscribeSharedLists]', err.code, err.message); onError?.(err); },
  );
}

export async function getSharedList(id) {
  const snap = await getDoc(doc(db, 'sharedLists', id));
  if (!snap.exists()) return null;
  return { id: snap.id, ...snap.data() };
}

// Individual reads can fail (e.g. permission-denied on someone else's
// foodPlaces doc) — skip those instead of rejecting the whole batch.
async function getPlacesByIds(collectionName, ids) {
  if (!ids.length) return [];
  const snaps = await Promise.all(
    ids.map(id => getDoc(doc(db, collectionName, id)).catch(() => null)),
  );
  return snaps.filter(s => s?.exists()).map(s => ({ id: s.id, ...s.data() }));
}

export const getProgramPlacesByIds = (ids) => getPlacesByIds('programPlaces', ids);
export const getPersonalPlacesByIds = (ids) => getPlacesByIds('foodPlaces', ids);
